import { Injectable, inject } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import {
  AcceptInvitationRequest,
  AcceptInvitationResponse,
  ResolveInvitationResponse,
} from '../../models/invitation/inviation.model';
import { ShiveNotificationService } from '../../services/controls/shive-notification.service';
import * as fromInvitationActions from '../invitation/invitation.actions';

@Injectable({
  providedIn: 'root',
})
export class InvitationHttpService {
  private readonly store = inject(Store);
  private readonly shiveNotificationService = inject(ShiveNotificationService);
  private readonly actions$ = inject(Actions);

  constructor() {
    // this.handleHttpCallbacks();
  }

  public createInvitation(email: string): Observable<void> {
    this.store.dispatch(fromInvitationActions.createInvitation({ email }));

    return this.actions$.pipe(
      ofType(fromInvitationActions.createInvitationSuccess),
      take(1),
      map(() => undefined),
    );
  }

  public resolveInvitation(token: string): Observable<ResolveInvitationResponse> {
    this.store.dispatch(fromInvitationActions.resolveInvitation({ token }));

    return this.actions$.pipe(
      ofType(fromInvitationActions.resolveInvitationSuccess),
      take(1),
      map((result) => result.payload),
    );
  }

  public acceptInvitation(
    firstName: string,
    lastName: string,
    password: string,
    passwordRepeat: string,
    token: string,
  ): Observable<AcceptInvitationResponse> {
    const acceptInvitationRequestModel = new AcceptInvitationRequest();
    acceptInvitationRequestModel.firstName = firstName;
    acceptInvitationRequestModel.lastName = lastName;
    acceptInvitationRequestModel.password = password;
    acceptInvitationRequestModel.passwordRepeat = passwordRepeat;
    acceptInvitationRequestModel.token = token;

    this.store.dispatch(
      fromInvitationActions.acceptInvitation({
        payload: acceptInvitationRequestModel,
      }),
    );

    return this.actions$.pipe(
      ofType(fromInvitationActions.acceptInvitationSuccess),
      map((result) => result.payload),
      take(1),
    );
  }
}
